<template>
  <v-flex style="display: flex; border-bottom: 1px solid #eee" justify-start>
    <f-time :offset="event.timeOffset" style="width: 10%"></f-time>
    <v-tooltip top style="width: 10%">
      <v-icon slot="activator">alarm</v-icon>
      <span>Timeout</span>
    </v-tooltip>
    <div style="display:flex; align-items: center">
      <f-flag :code="teams[event.noTeam].code" :height="20" :alt="teams[event.noTeam].code"></f-flag>
      <span>{{ teams[event.noTeam].name }}</span>
    </div>
  </v-flex>
</template>

<script>
import Time from './Time'
import Flag from '@/components/Flag'

export default {
  props: ['event', 'teams'],

  components: {
    'f-time': Time,
    'f-flag': Flag,
  },
}
</script>




// WEBPACK FOOTER //
// src/components/MatchLive/PlayByPlay/Timeout.vue